import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import API from "../api";
import { CURRENT_SEASON } from "../constants/season";
import { teamPageHref } from "./ui/MatchRow";

function TeamList({ title, rows, empty, competition }) {
  return (
    <div className="min-w-0">
      <h3 className="text-meta font-semibold text-muted mb-2">{title}</h3>
      {rows?.length ? (
        <ul className="space-y-2">
          {rows.map((team) => (
            <li key={team.team_name} className="flex items-baseline justify-between gap-3">
              <Link to={teamPageHref(competition, team.team_name)} className="truncate text-sm font-medium text-ink hover:underline">
                {team.team_name}
              </Link>
              <span className="shrink-0 text-meta tabular-nums text-muted">
                {Number(team.avg_points || 0).toFixed(1)}
                <span className="text-[11px]"> avg</span>
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-muted">{empty}</p>
      )}
    </div>
  );
}

export default function YourEdgeCard({ competition = "premier_league", season = CURRENT_SEASON }) {
  const { data, isLoading } = useQuery({
    queryKey: ["edgesKryptonite", competition, season],
    queryFn: () =>
      API.get("/predictions/edges-kryptonite", { params: { competition, season } }).then((res) => res.data),
    staleTime: 5 * 60 * 1000,
  });

  if (isLoading) return null;

  const edges = data?.edges || [];
  const kryptonite = data?.kryptonite || [];
  const empty = !edges.length && !kryptonite.length;

  return (
    <section className="rounded-xl border border-line bg-white shadow-sm overflow-hidden">
      <div className="px-4 md:px-5 py-3 border-b border-gray-100">
        <h2 className="text-[15px] font-semibold text-ink">Your edge</h2>
        <p className="text-[12px] text-muted">Average points when that team is in the match. At least 2 picks.</p>
      </div>
      {empty ? (
        <p className="px-4 md:px-5 py-4 text-sm text-muted">
          After a few Premier League picks, this shows the teams you read well.
        </p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 p-4 md:p-5">
          <TeamList title="You read well" rows={edges} empty="Not enough picks yet" competition={competition} />
          <TeamList title="You struggle" rows={kryptonite} empty="Not enough picks yet" competition={competition} />
        </div>
      )}
    </section>
  );
}
